import actions from './actions';
import mutations from './mutations';
var state = {
  has_mlops_active: false
};
export default {
  namespaced: true,
  state: state,
  actions: actions,
  mutations: mutations
};